import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["voteItem"]

  connect() {
    this.voteItemTargets.forEach(item => {
      this.toggleVoted(item)
    })
  }

  toggleVoted(target) {
    const categoryId = target.dataset.categoryId
    const productId = target.dataset.productId
    const cookie = this.getCookie(`afg_awards_vote_in_${categoryId}`)

    if (cookie === null) {
      this.toggleVoteButtons()
    }
    
    if (cookie === productId) {
      this.toggleVotedButton(target)
    }
  }

  toggleVoteButtons() {
    this.element.querySelectorAll(".vote").forEach(btn => {
      btn.classList.remove("invisible")
    })
  }

  toggleVotedButton(target) {
    const votedElement = target.querySelector(".voted")
    if (votedElement) {
      votedElement.classList.remove("invisible")
    }
  }

  getCookie(name) {
    const nameEQ = name + "="
    const cookies = document.cookie.split(";")
    
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i]
      while (cookie.charAt(0) === " ") {
        cookie = cookie.substring(1, cookie.length)
      }
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length, cookie.length)
      }
    }
    return null
  }
}
